import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <a 
            href="https://www.iscilab.com/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            {t('footer.iscilab')}
          </a>
          <Link to="/reviewer">{t('footer.reviewer')}</Link>
          <Link to="/admin">{t('footer.admin')}</Link>
        </div>
        
        <div className="footer-bottom">
          <p>
            <img src="/nexpa-logo.png" alt="Nexpa Logo" className="logo-img" width="20" height="20" /> 
            &copy; {currentYear} Nexpa. {t('footer.allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 